import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        disabled: '=',
        form: '='
    },
    template: `
    <div class="form" ng-if="vm.form.model.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT_PREDEFINED">
        <hr/>
        <form-row error="vm.form.errors.points">
            <label class="label">{{ 'questionAnswer.Points' | translate }}</label>
            <div class="items">
                <input ng-model="vm.form.model.points" type="number" class="form-control">
                <form-row-error></form-row-error>
            </div>
        </form-row>
        <form-row error="vm.form.errors.questionAnswers">
            <label class="label">{{ 'questionAnswer.Correct answers' | translate }}</label>
            <div class="items">
                <tags-input
                    ng-model="vm.tags"
                    placeholder="{{ 'questionAnswer.Add answer' | translate }}"
                    min-length="2"
                    replace-spaces-with-dashes="0"
                    on-tag-adding="vm.addTag($tag)"
                    on-tag-removed="vm.removeTag($tag)"
                    ></tags-input>
                <p class="desc">{{ 'questionAnswer.predefined_answers_helptext' | translate }}</p>
            </div>
        </form-row>
    </div>
    `
})

export default class {
    constructor (lodash,
                 QUESTIONS_TYPE_ENUM, QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM) {
        this.lodash = lodash;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM = QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM;
    }

    $onInit () {
        this.tags = this.form.model.questionAnswers.map((answer) => {
            return { text: answer.name };
        });
    }

    addTag (tag) {
        this.form.model.questionAnswers.push({
            correctness: this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.CORRECT,
            name: tag.text
        });
    }

    removeTag (tag) {
        this.lodash.remove(this.form.model.questionAnswers, {
            name: tag.text
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/answers/freeTextPredefinedType/index.js